import { Spinner } from '@/components/ui/spinner';

/** A spinner and a word, for a screen waiting on its first data. */
export function Loading({ label = 'Loading…' }: Readonly<{ label?: string }>) {
  return (
    <output className="flex items-center gap-2 text-sm text-muted-foreground">
      <Spinner />
      {label}
    </output>
  );
}

/** A bare spinner, for inside a small control while its call is running. */
export function Spin({ className }: Readonly<{ className?: string }>) {
  return <Spinner className={className} />;
}
